import React, { FC } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './QueryClient';

const QueryClientComponent: FC = ({ children }): React.ReactElement => (
  <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

export default QueryClientComponent;
